<template>
  <router-view></router-view>
  <ToastNotification />
  <ViewAsTeam />
</template>

<script>
import ToastNotification from "./components/Library/ToastNotification.vue";
import ViewAsTeam from "./components/Library/ViewAsTeam.vue";

export default {
  components: {
    ToastNotification,
    ViewAsTeam,
  },
};
</script>
